import React from 'react';

export default function ProductionFilesTable({ files, backendUrl }) {

  const productionFiles = files.filter((f) => f._prod === true);

  // Sort files by creation date, newest first
  productionFiles.sort((a, b) => {
    const da = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const db = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return db - da;
  });

  if (productionFiles.length === 0) {
    return null; // Don't render the section if there are no production files
  }

  return (
    <div className="production-files-section">
      <h3 className="section-title">Pliki produkcyjne</h3>
      <table className="files-table production-files-table">
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Nazwa pliku</th>
            <th style={{ textAlign: 'left' }}>Data utworzenia</th>
            <th style={{ textAlign: 'left' }}>Pobierz</th>
          </tr>
        </thead>
        <tbody>
          {productionFiles.map((pf) => (
            <tr key={pf.id}>
              <td>{pf.fileName}</td>
              <td>
                {pf.createdAt ? new Date(pf.createdAt).toLocaleString() : "-"}
              </td>
              <td>
                <a
                  href={`${backendUrl}/admin/files/${pf.downloadKey}`}
                  download={pf.fileName}
                  className="action-link"
                >
                  Pobierz
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
